




import DynamicComponent from './DynamicComponent'
import TiwiMixin from '../mixins/TiwiMixin'
export default {
  mixins: [ TiwiMixin ],
  components: {
    DynamicComponent
  },
  props: {
   
  },
  data() {
		return {
      content: null,
		}
	},
  mounted: function() {
		
    
	},
  watch: {
    overlay: function( newVal, oldVal ){
        if( newVal ){
          // blocco lo scroll
          jQuery('body').addClass('overflow-hidden');

          // rieseguo i js, per esempio per gli splide
          this.$nextTick( function(){
            window.enablePageJs('.vue-overlay-container');
          });
          
          this.content = newVal.content;
        }
        else{
          jQuery('body').removeClass('overflow-hidden');
          this.content = null;
        }

    }
  },
  computed: {
   
  }
}
